import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

@Injectable({ providedIn: 'root' })
export class InitResolver  {

    private promise: Promise<undefined>;
    private defered: {resolve: any, reject: any};

    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.defered = {
                resolve: resolve,
                reject: reject
            };
        })
    }

    /** Az induláskori ellenőrzés (users/me) lefutott — az útvonal-őr erre vár. */
    whenReady(): Promise<undefined> {
        return this.promise;
    }

    ready() {
        this.defered.resolve();
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        return this.promise
    }

}
